<template>
  <v-card flat>
    <v-card-text class="report-page content-500">
      <h2 class="page-title">Report for {{ room.label }}</h2>
      <v-form v-model="formValid" ref="form" name="form">
        <table class="table table__report">
          <colgroup>
            <col>
            <col>
            <col width="125px">
            <col>
          </colgroup>
          <thead>
            <tr>
              <th role="columnheader" class="text-xs-left pr-1 pl-0 body-2">
                <strong>Help</strong>
              </th>
              <th role="columnheader" class="text-xs-left pr-1 pl-0 body-2">
                <strong>Resource</strong>
              </th>
              <th role="columnheader" class="text-xs-center px-1 body-2">
                <v-layout row justify-space-between>
                  <strong class="pr-2">Working</strong>
                  <strong class="pl-2">Broken</strong>
                </v-layout>
              </th>
              <th role="columnheader" class="text-xs-center pl-1 pr-0 body-2">
                <strong>Notes</strong>
              </th>
            </tr>
          </thead>
          <template v-for="(field, index) in inventory">
            <tr v-bind:key="index" ripple class="field px-0">
              <td class="text-xs-left">
                <v-dialog v-model="form[field.featureId].issueHelp" persistent max-width="350">
                  <v-btn class="ml-0" flat icon v-if="field.featureLink" slot="activator">
                    <v-icon class="help-btn">help</v-icon>
                  </v-btn>
                  <v-card>
                    <v-toolbar card>
                      <v-toolbar-title>Help: {{ field.featureName }}</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                        right
                        color
                        @click.native="form[field.featureId].issueHelp = false"
                      >
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <iframe
                      :id="field.featureId + '_frame'"
                      :src="field.featureLink"
                      class="iframe__help"
                      width="100%"
                      height="450px"
                    ></iframe>
                  </v-card>
                </v-dialog>
              </td>

              <td class="text-xs-left">
                <span class="resource-name py-1">{{ field.featureName }}</span>
                <span class="resource-description pb-1">{{ field.featureDescription }}</span>
              </td>

              <td class="text-xs-center px-2">
                <v-radio-group
                  class="radio_group__feature_status pt-0"
                  v-model="form[field.featureId].status"
                  :name="'form[' + field.featureId + '_status]'"
                  :ref="field.featureId + '_status'"
                  :rules="[v => v !== null || '']"
                  row
                  hide-details
                >
                  <v-radio
                    class="radio__feature_status__working pl-2"
                    :value="true"
                    color="success"
                  ></v-radio>
                  <v-radio class="radio__feature_status__broken pr-1" :value="false" color="error"></v-radio>
                </v-radio-group>
              </td>

              <td class="text-xs-left">
                <v-btn
                  color="grey"
                  class="mr-0"
                  flat
                  depressed
                  small
                  fab
                  @click="showDialog(form[field.featureId])"
                >
                  <v-icon v-if="form[field.featureId].issueDescription">insert_comment</v-icon>
                  <v-icon v-else>mode_comment</v-icon>
                  <span
                    class="error--text required-marker"
                    v-show="form[field.featureId].status !== true"
                  >•</span>
                </v-btn>

                <v-dialog v-model="form[field.featureId].issueDialog" persistent max-width="350">
                  <v-card>
                    <v-card-text>
                      

                      <v-text-field
                        :ref="field.featureId + '_issueDescription'"
                        :name="'form[' + field.featureId + '_issueDescription]'"
                        label="Issue Description"
                        :rules="[
                          function(v) {
                            return Boolean(
                              form[field.featureId].status === true ||
                              (typeof v === 'string' && v.length)
                            ) || 'Required';
                          },
                          (v) => v.length <= 140 || 'Max 140 characters'
                        ]"
                        multi-line
                        :counter="140"
                        v-model="form[field.featureId].issueDescription"
                      ></v-text-field>

                      <p
                        class="py-2"
                      >Remember: This description will be visible to clients. Please keep all language clear and professional.</p>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        color="grey"
                        flat
                        @click.stop="deleteIssueDialog(form[field.featureId])"
                      >
                        <v-icon left>delete</v-icon>
                        <span class="btn__text">Discard</span>
                      </v-btn>
                      <v-btn
                        color="primary"
                        flat
                        @click.stop="saveIssueDialog(form[field.featureId])"
                      >
                        <v-icon left>save</v-icon>
                        <span class="btn__text">Save</span>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
            </tr>
          </template>
        </table>

        <div class="text-xs-center my-4">
          <v-btn
            @click="submitReport()"
            :disabled="!formValid"
            color="success"
            class="btn__submit_report"
          >
            <v-icon left>send</v-icon>
            <span class="btn__text">Submit Report</span>
          </v-btn>

          <v-dialog v-model="thankYouDialog" persistent max-width="350">
            <v-card>
              <v-card-title primary-title class="headline">Thank You!</v-card-title>
              <v-card-text>
                <p>Thank you for reporting! Your report has been queued, and will be sent shortly.</p>
                <p>You may return to the Room Picker now, using the button below, or you will be redirected there automatically in {{ roomPickerRedirectDelaySeconds }} seconds.</p>
                <div class="text-xs-center">
                  <v-btn color="primary" @click.native="goToRoomPicker()">
                    <v-icon left>forward</v-icon>
                    <span class="btn__text">Back to Room Picker</span>
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<style>
li.px-0 > .list__tile {
  padding: 0;
}
.table__report td {
  width: 30px;
}
.table__report td:nth-child(2) {
  width: auto;
}
.required-marker {
  position: absolute;
  top: 5px;
  right: 5px;
}
.iframe__help {
  border-width: 0;
  border-style: none;
}
form .radio_group__feature_status .radio,
form .radio_group__feature_status .radio .input-group__input {
  max-width: 48px;
}
form .radio_group__feature_status > .input-group__input {
  justify-content: space-around;
}
form
  .radio_group__feature_status
  > .input-group__input
  .radio__feature_status__broken
  > .input-group__input {
  flex-direction: row-reverse;
}
form
  .radio_group__feature_status
  > .input-group__input
  .radio__feature_status__broken
  > .input-group__input
  .icon {
  left: inherit;
  right: 0;
}
form .radio_group__feature_status > .input-group__input label {
  display: none;
}
form
  .radio_group__feature_status
  > .input-group__input
  .radio__feature_status__broken
  > .input-group__input
  .input-group--selection-controls__ripple {
  -webkit-transform: translate3d(9px, -50%, 0);
  transform: translate3d(9px, -50%, 0);
}
</style>

<script>
import Vue from "vue";
// Load TMP footprints services and categories fields.
// import * as FOOTPRINTS_SERVICES_AND_CATEGORIES from '@/data/sample-footprints-service-categories.json'

// TODO: Nick thinks status should be radio buttons, start in null state
export default {
  name: "Report",
  data() {
    return {
      room: {},
      formValid: false,
      inventory: [],
      form: Vue.$roomService.getRoomInventoryForm(this.roomId),
      roomPickerRedirectDelaySeconds: 3,
      thankYouDialog: false
    };
  },
  props: {
    teamId: {
      type: String,
      required: true
    },
    roomId: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.room = this.$roomService.getRoom(this.roomId);
      this.inventory = this.$roomService.getRoomInventory(this.roomId);
    },
    submitReport() {
      if (this.$refs.form.validate()) {
        this.thankYouDialog = true;
        setTimeout(
          this.sendReport,
          (this.roomPickerRedirectDelaySeconds + 1) * 1000
        );
        setTimeout(
          this.goToRoomPicker,
          this.roomPickerRedirectDelaySeconds * 1000
        );
      }
    },
    sendReport() {
      // Send report to sync service
      this.$syncService.add(this.submissionData);
    },
    goToRoomPicker() {
      // Redirect to room picker to select another room
      const teamId = this.teamId;
      this.$router.push({
        path: `/${teamId}/room`
      });
    },
    showDialog(field) {
      field.issueDialog = true;
    },
    saveIssueDialog(field) {
      field.issueDialog = false;
      if (
        typeof field.issueDescription === "string" &&
        field.issueDescription.length &&
        field.status === null
      ) {
        field.status = false;
      }
    },
    deleteIssueDialog(field) {
      field.issueDescription = "";
      field.issueDialog = false;
    }
  },
  computed: {
    roomStatus() {
      return !Object.values(this.featureStatusObject).filter(it => it !== true)
        .length
        ? "working"
        : "broken";
    },
    submissionData() {
      var user = this.$auth.user();
      var userId = user.uid ? user.uid : "missing";
      return {
        room: this.room,
        roomId: this.roomId,
        label: this.room.label,
        userId: userId,
        user: user,
        form: this.form,
        roomStatus: this.roomStatus,
        teamId: this.teamId
      };
    },
    featureStatusObject() {
      return Object.entries(this.form)
        .map(it => [it[0], it[1].status])
        .reduce((prev, curr) => {
          prev[curr[0]] = curr[1];
          return prev;
        }, {});
    },
    featureStatusIncompleteCount() {
      return Object.entries(this.featureStatusObject)
        .map(it => it[1])
        .filter(it => it === null).length;
    }
  },
  watch: {
    featureStatusObject: {
      deep: true,
      handler: function(newVal, oldVal) {
        // Validate issue description whenever value of issue status is changed
        var changedFeatureId = Object.entries(newVal)
          .filter(it => oldVal[it[0]] !== it[1])
          .pop()
          .reverse()
          .pop();
        this.$nextTick(t => {
          this.$refs[changedFeatureId + "_issueDescription"][0].validate();
        });
      }
    },
    featureStatusIncompleteCount: function(newVal, oldVal) {
      // Validate entire form once all status fields have been populated
      if (!newVal) {
        this.$nextTick(t => {
          this.$refs.form.validate();
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Report.vue